import React, { useRef, useState } from 'react';

function App() {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [image, setImage] = useState(null);
  const [countdown, setCountdown] = useState(0);
  const [uploading, setUploading] = useState(false);

  // 打开摄像头
  const startCamera = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    videoRef.current.srcObject = stream;
  };

  // 延时5秒拍照
  const takePhoto = () => {
    setCountdown(5);
    let timer = 5;
    const interval = setInterval(() => {
      timer--;
      setCountdown(timer);
      if (timer === 0) {
        clearInterval(interval);
        const video = videoRef.current;
        const canvas = canvasRef.current;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);
        setImage(canvas.toDataURL('image/png'));
      }
    }, 1000);
  };

  // 上传图片
  const uploadPhoto = async () => {
    if (!image) return;
    setUploading(true);
    const blob = await (await fetch(image)).blob();
    const formData = new FormData();
    formData.append('file', blob, 'photo.png');
    await fetch('/api/upload', {
      method: 'POST',
      body: formData,
    });
    setUploading(false);
    alert('上传成功！');
  };

  return (
    <div style={{ textAlign: 'center', marginTop: 40 }}>
      <h2>换装功能延时拍照</h2>
      <video ref={videoRef} autoPlay style={{ width: 1200 }} />
      <br />
      <button onClick={startCamera}>打开摄像头</button>
      <button onClick={takePhoto} disabled={countdown > 0}>延时5秒拍照</button>
      {countdown > 0 && <div>倒计时：{countdown} 秒</div>}
      <canvas ref={canvasRef} style={{ display: 'none' }} />
      {image && (
        <div>
          <h4>预览：</h4>
          <img src={image} alt="拍照" style={{ width: 1200 }} />
          <br />
          <button onClick={uploadPhoto} disabled={uploading}>{uploading ? '上传中...' : '上传到云服务器'}</button>
        </div>
      )}
    </div>
  );
}

export default App; 